<!-- 部门操作 -->
<template>
    <div>
        <el-dialog :visible.sync="dataActionBox.showStatus" v-if="dataActionBox.showStatus" :title="dataActionBox.boxTitle" :close-on-click-modal="false" append-to-body center top="30px" width="500px">
            <div :style="`height: ${treeHeight}px;overflow: auto;`">
                <el-tree ref="tree" :data="data" :props="defaultProps" :default-expanded-keys="dataKeys" :expand-on-click-node="false" node-key="jurId" v-if="flag"  highlight-current>
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>
                        <span>
                            <el-button type="text" size="mini" @click="toTop(node,data)">
                                上移
                            </el-button>
                            <el-button type="text" size="mini" @click="toBottom(node, data)">
                                下移
                            </el-button>
                        </span>
                    </span>
                </el-tree>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dataActionBox.showStatus = false">取 消</el-button>
                <el-button type="primary" @click="sendDataAction">确 定</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: 'menuSort',
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '菜单排序',
                actionType: 0, // 0新增，1修改
            },
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            data: [],
            flag: true,
            sendDataInfo: {
                "TYPE": 'UPD_INDEX',
                "jurId": 0,
                "MENUNAME": "",
                "ICONNAME": "",
                "MENUURL": "",
                "MENULEVEL": 0,
                "jurSort": 0,
                "jurParentid": 0,
                "TEMPID": 0,
                item: {
                    tablename: 'TMP_MENUMAN',
                    rows: []
                }
            },
            treeHeight:500,
            dataKeys:[],

        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        getOneIndex(id) {
            let index = ''
            this.data.forEach((item, i) => {
                if (id == item.jurId) {
                    index = i
                }
            })
            return index
        },
        getNowPaIndex(id) {
            let nowIndex = ''
            this.data.forEach((item, index) => {
                if (id == item.jurId) {
                    nowIndex = index
                }
            })
            return nowIndex
        },
        getNowChIndex(id) {
            let nowChildIndex = ''
            this.data.forEach((item, index) => {
                if (item.children) {
                    item.children.forEach((key, i) => {
                        if (id == key.jurId) {
                            nowChildIndex = i
                        }
                    })
                }
            })
            return nowChildIndex
        },
        getThreeChIndex(id, nowIndex) {
            let nowChildIndex = ''
            let oneIndex = ''
            this.data.forEach((item, index) => {
                if (item.children) {
                    if (item.children[nowIndex]) {
                        if (item.children[nowIndex].children) {
                            item.children[nowIndex].children.forEach((key, i) => {
                                if (id == key.jurId) {
                                    nowChildIndex = i
                                    oneIndex = index
                                }
                            })
                        }
                    }
                }
            })
            return {
                nowChildIndex: nowChildIndex,
                oneIndex: oneIndex,
            }
        },
        toTop(node, row) {
            this.dataKeys=[row.jurId]
            if (row.jurStype === 0) {
                let index = this.getOneIndex(row.jurId)
                console.log(index)
                if (index != 0) {
                    this.data.splice(index - 1, 1, ...this.data.splice(index, 1, this.data[index - 1]));
                    this.data.forEach((item, i) => {
                        item.jurSort = i
                    });
                    this.flag = false
                    this.$nextTick(() => {
                        this.flag = true
                        this.$nextTick(() => {
                            this.$refs.tree.setCurrentKey(row.jurId)
                        })
                    })
                } else {
                    return this.$message({
                        message: "无法上移",
                        type: "warning",
                    });
                }
            } else if (row.jurStype === 1) {
                let nowIndex = this.getNowPaIndex(row.jurParentid) // 当前父级index
                let nowChildIndex = this.getNowChIndex(row.jurId) //当前子菜单id
                console.log(nowChildIndex);
                if (nowChildIndex != 0) {
                    this.data[nowIndex].children.splice(nowChildIndex - 1, 1, ...this.data[nowIndex].children.splice(nowChildIndex, 1, this.data[nowIndex].children[nowChildIndex - 1]));
                    this.data[nowIndex].children.forEach((item, i) => {
                        item.jurSort = i
                    });
                    this.flag = false
                    this.$nextTick(() => {
                        this.flag = true
                        this.$nextTick(() => {
                            this.$refs.tree.setCurrentKey(row.jurId)
                        })
                    })
                } else {
                    return this.$message({
                        message: "无法上移",
                        type: "warning",
                    });
                }
            } else{
                let nowIndex = this.getNowChIndex(row.jurParentid) //当前子菜单id
                let oneIndex = this.getThreeChIndex(row.jurId, nowIndex).oneIndex
                let nowChildIndex = this.getThreeChIndex(row.jurId, nowIndex).nowChildIndex
                if (nowChildIndex != 0) {
                    this.data[oneIndex].children[nowIndex].children.splice(nowChildIndex - 1, 1, ...this.data[oneIndex].children[nowIndex].children.splice(nowChildIndex, 1, this.data[oneIndex].children[nowIndex].children[nowChildIndex - 1]));
                    this.data[oneIndex].children[nowIndex].children.forEach((item, i) => {
                        item.jurSort = i
                    });
                    this.flag = false
                    this.$nextTick(() => {
                        this.flag = true
                        this.$nextTick(() => {
                            this.$refs.tree.setCurrentKey(row.jurId)
                        })
                    })
                } else {
                    return this.$message({
                        message: "无法上移",
                        type: "warning",
                    });
                }
            }

        },
        toBottom(node, row) {
            this.dataKeys=[row.jurId]
            console.log(node, row)
            console.log(row.jurSort)
            if (row.jurStype === 0) {
                let index = this.getOneIndex(row.jurId)
                let lg = this.data.length - 1;
                if (index != lg) {
                    this.data.splice(index, 1, ...this.data.splice(index + 1, 1, this.data[index]));
                    this.data.forEach((item, i) => {
                        item.jurSort = i
                    });
                    this.flag = false
                    this.$nextTick(() => {
                        this.flag = true
                        this.$nextTick(() => {
                            this.$refs.tree.setCurrentKey(row.jurId)
                        })
                    })
                } else {
                    return this.$message({
                        message: "无法下移",
                        type: "warning",
                    });
                }
            } else if (row.jurStype === 1) {
                let nowIndex = this.getNowPaIndex(row.jurParentid) // 当前父级index
                let nowChildIndex = this.getNowChIndex(row.jurId) //当前子菜单id
                let lg = this.data[nowIndex].children.length - 1
                if (nowChildIndex != lg) {
                    this.data[nowIndex].children.splice(nowChildIndex, 1, ...this.data[nowIndex].children.splice(nowChildIndex + 1, 1, this.data[nowIndex].children[nowChildIndex]));
                    this.data[nowIndex].children.forEach((item, i) => {
                        item.jurSort = i
                    });
                    this.flag = false
                    this.$nextTick(() => {
                        this.flag = true
                        this.$nextTick(() => {
                            this.$refs.tree.setCurrentKey(row.jurId)
                        })
                    })
                } else {
                    return this.$message({
                        message: "无法下移",
                        type: "warning",
                    });
                }
                console.log('阿凡达发达范德萨', nowIndex, nowChildIndex)
            } else {
                let nowIndex = this.getNowChIndex(row.jurParentid) //当前子菜单id
                let oneIndex = this.getThreeChIndex(row.jurId, nowIndex).oneIndex
                let nowChildIndex = this.getThreeChIndex(row.jurId, nowIndex).nowChildIndex
                let lg = this.data[oneIndex].children[nowIndex].children.length - 1
                if (nowChildIndex != lg) {
                    this.data[oneIndex].children[nowIndex].children.splice(nowChildIndex, 1, ...this.data[oneIndex].children[nowIndex].children.splice(nowChildIndex + 1, 1, this.data[oneIndex].children[nowIndex].children[nowChildIndex]));
                    this.data[oneIndex].children[nowIndex].children.forEach((item, i) => {
                        item.jurSort = i
                    });
                    this.flag = false
                    this.$nextTick(() => {
                        this.flag = true
                        this.$nextTick(() => {
                            this.$refs.tree.setCurrentKey(row.jurId)
                        })
                    })
                } else {
                    return this.$message({
                        message: "无法下移",
                        type: "warning",
                    });
                }
            }
        },
        handleNodeClick(data) {
            //  console.log(data);
        },
        openBox(data) {
            this.data = JSON.parse(JSON.stringify(data))
            this.dataActionBox.showStatus = true
            this.$nextTick(()=>{
                this.treeHeight=document.documentElement.clientHeight-200
            })
        },
        async sendDataAction() {
            let paData = []
            this.data.forEach(item => {
                paData.push({ jurId: item.jurId, jurSort: item.jurSort })
                if (item.children) {
                    item.children.forEach(item1 => {
                        paData.push({ jurId: item1.jurId, jurSort: item1.jurSort })
                        if (item1.children) {
                            item1.children.forEach(val => {
                                paData.push({ jurId: val.jurId, jurSort: val.jurSort })
                            })
                        }
                    })
                }
            })
            var responseData = await this.$http.JurisdictionUpdateSort(paData)
            if (responseData.status == 200) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.dataActionBox.showStatus = false
                this.$parent.getJurisdictionList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },



    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
<style scoped>
::v-deep
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #f0cf16 !important;
}
</style>